module.exports = __webpack_public_path__ + "img/boat3.1b41e97f.jpg";